import { Component, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl, ValidatorFn } from '@angular/forms';
import { AssistantPopoverService } from '../../../../common/assistant-popover.service';
import { ValidationService } from '../../../../common/validation.service';
import { leapDayValidator } from '../../../../common/validators';
import { VisumErfassungSubFormComponent } from '../../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-fruehere-aufenthalte',
  templateUrl: './fruehere-aufenthalte.component.html',
  styleUrls: ['./fruehere-aufenthalte.component.scss']
})
export class FruehereAufenthalteComponent extends VisumErfassungSubFormComponent implements OnInit {


  constructor(fb: FormBuilder,
              protected validationService: ValidationService,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    const ortValidators: ValidatorFn[] = validationService.getValidators('fruehereReisen.aufenthaltListe.ort');
    const vonValidators: ValidatorFn[] = validationService.getValidators('fruehereReisen.aufenthaltListe.von');
    const bisValidators: ValidatorFn[] = validationService.getValidators('fruehereReisen.aufenthaltListe.bis');
    this.form = this.wrapFormGroup(fb.group({
      AufenthaltBRDJa: [null, validationService.getValidators('fruehereReisen.AufenthaltBRDJa')],
      aufenthaltOrt1: [null, ortValidators],
      aufenthaltVon1: [null, [...vonValidators, leapDayValidator]],
      aufenthaltBis1: [null, [...bisValidators, leapDayValidator]],
      aufenthaltOrt2: [null, ortValidators],
      aufenthaltVon2: [null, [...vonValidators, leapDayValidator]],
      aufenthaltBis2: [null, [...bisValidators, leapDayValidator]],
      aufenthaltOrt3: [null, ortValidators],
      aufenthaltVon3: [null, [...vonValidators, leapDayValidator]],
      aufenthaltBis3: [null, [...bisValidators, leapDayValidator]],
      aufenthaltOrt4: [null, ortValidators],
      aufenthaltVon4: [null, [...vonValidators, leapDayValidator]],
      aufenthaltBis4: [null, [...bisValidators, leapDayValidator]],
      aufenthaltOrt5: [null, ortValidators],
      aufenthaltVon5: [null, [...vonValidators, leapDayValidator]],
      aufenthaltBis5: [null, [...bisValidators, leapDayValidator]]
    }));
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
